import validate from "/app/seame-web-b2b/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.6.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_comm_mtinmsannowavapelhrobmcmsu/node_modules/nuxt/dist/pages/runtime/validate.js";
import h5_45auth_45global from "/app/seame-web-b2b/apps/web-b2b/middleware/h5-auth.global.ts";
import h5_45redirect_45global from "/app/seame-web-b2b/apps/web-b2b/middleware/h5-redirect.global.ts";
import manifest_45route_45rule from "/app/seame-web-b2b/node_modules/.pnpm/nuxt@3.20.2_@parcel+watcher@2.5.4_@types+node@25.6.0_@vue+compiler-sfc@3.5.27_cac@6.7.14_comm_mtinmsannowavapelhrobmcmsu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  h5_45auth_45global,
  h5_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}